module Meevo.Plugins.DrawerManager {
    "use strict";

    export class UnassignedDrawerSection extends Meevo.Plugins.DrawerManager.DrawerManagerSectionBase {
        public selectedDrawer: Meevo.Model.Drawer;

        constructor(protected drawerManagerContext: Meevo.Plugins.DrawerManager.DrawerManagerContext,
            protected dataService: Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            private $translate: angular.translate.ITranslateService,
            personalHeader:boolean,
            personalFooter:boolean) {

            super(DrawerManager.DrawerManagerSectionTypeEnum.UnassignedDrawer, drawerManagerContext, "unassignedDrawer", personalHeader, personalFooter);

        }

        reset() {
            super.reset();
        }

        selectDrawer() {
            this.context.setSelectedDrawer(this.selectedDrawer);
        }

        getSectionName() {
            return "Please select a drawer";
        }
    }

}